import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = {
  key: 0,
  class: "filters"
}
const _hoisted_3 = { class: "filter-block" }
const _hoisted_4 = { class: "quality-buttons" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "filter-block" }
const _hoisted_7 = { class: "quality-buttons" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "filter-block" }
const _hoisted_10 = { class: "quality-buttons" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "filter-block" }
const _hoisted_13 = { class: "search-input-group" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"font-size":"12px","color":"gray"} }
const _hoisted_17 = {
  key: 0,
  style: {"font-size":"12px","color":"gray"}
}
const _hoisted_18 = { style: {"font-size":"12px","color":"gray"} }
const _hoisted_19 = {
  key: 0,
  style: {"font-size":"12px","color":"gray"}
}
const _hoisted_20 = { style: {"font-size":"12px","color":"gray"} }
const _hoisted_21 = {
  key: 0,
  style: {"font-size":"11px","color":"#888"}
}
const _hoisted_22 = {
  key: 0,
  style: {"font-size":"12px","color":"gray"}
}
const _hoisted_23 = ["onClick"]

import { computed, ref, reactive } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import Tooltip from 'primevue/tooltip'
import AutoComplete from 'primevue/autocomplete'
import MultiSelect from 'primevue/multiselect'
import { copyText } from 'vue3-clipboard'
import { QUALITY_LIST, MODULE_STATS } from '@/components/module/data'

interface AuctionLot {
  itemId: string
  startPrice: number
  buyoutPrice: number
  additional: any
  salesCount: number
  information: any
  prefix: any
  suffix: any
  affix: any
}

/* сортировка по умолчанию */

export default /*@__PURE__*/_defineComponent({
  __name: 'ModuleTable',
  props: {
    lots: {},
    dashboard: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const multiSortMeta = ref([{ field: 'score', order: -1 }])

const filteredRows = computed(() => {
  if (props.dashboard) {
    return rows.value.filter(i => i.score > 0 && i.buyoutPrice)
  } else {
    return rows.value
  }
})

/* подготовка строк таблицы с учетом комиссии 5% и фильтрации */
const rows = computed(() => {
  if (!props.lots.length) return []

  let filteredLots = props.lots

  // Фильтрация по атрибутам и качествам
  filteredLots = filteredLots.filter(lot => {
    // Проверяем префиксы
    if (filters.prefixDefinitionIds.length > 0) {
      const prefixId = lot.prefix?.definitionId
        ?.replace(/_(pre|suf|aff)$/g, '')
        .replace(/_(pre|suf|aff)_?/g, '')
      if (!prefixId || !filters.prefixDefinitionIds.includes(prefixId)) return false

      if (filters.prefixQualities.length > 0) {
        if (!filters.prefixQualities.includes(lot.prefix?.quality ?? 0)) return false
      }
    }

    // Проверяем суффиксы
    if (filters.suffixDefinitionIds.length > 0) {
      const suffixId = lot.suffix?.definitionId
        ?.replace(/_(pre|suf|aff)$/g, '')
        .replace(/_(pre|suf|aff)_?/g, '')
      if (!suffixId || !filters.suffixDefinitionIds.includes(suffixId)) return false

      if (filters.suffixQualities.length > 0) {
        if (!filters.suffixQualities.includes(lot.suffix?.quality ?? 0)) return false
      }
    }

    // Проверяем аффиксы
    if (filters.affixDefinitionIds.length > 0) {
      const affixId = lot.affix?.definitionId
        ?.replace(/_(pre|suf|aff)$/g, '')
        .replace(/_(pre|suf|aff)_?/g, '')
      if (!affixId || !filters.affixDefinitionIds.includes(affixId)) return false

      if (filters.affixQualities.length > 0) {
        if (!filters.affixQualities.includes(lot.affix?.quality ?? 0)) return false
      }
    }

    return true
  })

  // Фильтрация по поисковому запросу
  if (searchQuery.value && typeof searchQuery.value === 'string') {
    const query = searchQuery.value.toLowerCase()
    filteredLots = filteredLots.filter(lot => {
      const prefixName = lot.prefix?.name?.toLowerCase() || ''
      const suffixName = lot.suffix?.name?.toLowerCase() || ''
      const affixName = lot.affix?.name?.toLowerCase() || ''

      return prefixName.includes(query) || suffixName.includes(query) || affixName.includes(query)
    })
  } else if (searchQuery.value && typeof searchQuery.value === 'object' && searchQuery.value.name) {
    // Если выбрано из автокомплита
    const query = searchQuery.value.name.toLowerCase()
    filteredLots = filteredLots.filter(lot => {
      const prefixName = lot.prefix?.name?.toLowerCase() || ''
      const suffixName = lot.suffix?.name?.toLowerCase() || ''
      const affixName = lot.affix?.name?.toLowerCase() || ''

      return prefixName.includes(query) || suffixName.includes(query) || affixName.includes(query)
    })
  }

  return filteredLots.map(l => {
    const price = l.information?.price ?? 0
    const buyout = l.buyoutPrice ?? 0
    const salesCount = l.information.salesCount ?? 0
    const liquidityPerDay = l.information.liquidityPerDay ?? 0
    const affixPrice = l.information.affixPrice ?? 0
    const affixLiquidityPerDay = l.information.affixLiquidityPerDay ?? 0
    const affixSalesCount = l.information.affixSalesCount ?? 0
    const AC = l.information.AC
    const BC = l.information.BC
    const ACPrice = l.information.AC?.avgPrice
    const BCPrice = l.information.BC?.avgPrice
    const ACSalesCount = l.information.AC?.salesCount ?? 0
    const BCSalesCount = l.information.BC?.salesCount ?? 0

    // const affix = l?.additional?.attributes?.find(i => i.type === 2)
    // const statsRandom = affix?.statsRandom
    // const definitionId = affix?.definitionId

    // Расчет рыночной цены с учетом всех компонентов
    let marketPriceComponents = []
    let totalWeight = 0

    // Базовые веса для каждого типа данных
    const affixWeight = Math.min(affixSalesCount / 20, 1) // вес до 1.0
    const acWeight = ACSalesCount > 10 ? Math.min(ACSalesCount / 30, 1.2) : 0 // вес до 1.2
    const bcWeight = BCSalesCount > 10 ? Math.min(BCSalesCount / 30, 1.2) : 0 // вес до 1.2

    // Добавляем только если есть достаточные продажи
    if (affixPrice && affixSalesCount > 0) {
      marketPriceComponents.push({ price: affixPrice, weight: affixWeight })
      totalWeight += affixWeight
    }

    if (ACPrice && ACSalesCount > 10) {
      marketPriceComponents.push({ price: ACPrice, weight: acWeight })
      totalWeight += acWeight
    }

    if (BCPrice && BCSalesCount > 10) {
      marketPriceComponents.push({ price: BCPrice, weight: bcWeight })
      totalWeight += bcWeight
    }

    // Взвешенная средняя цена
    const weightedMarketPrice =
      marketPriceComponents.reduce((sum, comp) => sum + comp.price * comp.weight, 0) / totalWeight

    // Расчет дисперсии и коэффициента вариации для оценки надежности
    const validPrices = marketPriceComponents.map(comp => comp.price)
    const priceVariance =
      validPrices.length > 1
        ? validPrices.reduce((sum, price) => sum + Math.pow(price - weightedMarketPrice, 2), 0) /
          validPrices.length
        : 0
    const priceStdDev = Math.sqrt(priceVariance)
    const coefficientOfVariation =
      weightedMarketPrice > 0 ? (priceStdDev / weightedMarketPrice) * 100 : 0

    // учитываем комиссию 5% при продаже
    const netMarketPrice = weightedMarketPrice * 0.95
    const profit = netMarketPrice - buyout

    // Формула расчета score с балансом ЛИКВИДНОСТЬ + ЦЕНА + ПРОФИТ + НАДЕЖНОСТЬ
    // salesScore - умеренный бонус за продажи (0=500, 1-2=800, 3-5=1200, 6+=100*кол-во)
    // liquidityScore - главный фактор ликвидности (×200)
    // profitScore - профит важен (положительный ×1.5, отрицательный ×2)
    // affixLiquidityScore - ликвидность аффикса (×50)
    // optimalPriceBonus - оптимальная цена покупки (≤200к=1500, ≤500к=2000, ≤1млн=1000, ≤2млн=500)
    // goodDataBonus - бонус за стабильные данные (до 1200)
    // stabilityScore - стабильность цен (-500 до +400)
    // reliabilityScore - надежность данных (0 до 1500) - НОВЫЙ БОНУС
    // balanceMultiplier - мультипликатор за баланс (1.0 до 1.3)

    // Базовые показатели - баланс ликвидности, цены и профита
    const salesScore =
      salesCount === 0 ? 500 : salesCount <= 2 ? 800 : salesCount <= 5 ? 1200 : salesCount * 100 // умеренный бонус за продажи
    const liquidityScore = liquidityPerDay * 200 // высокий вес ликвидности (главный фактор)
    const profitScore = profit * 0.0001
    const affixLiquidityScore = affixLiquidityPerDay * 50 // ликвидность аффикса

    // Бонус за оптимальную цену покупки (не слишком дешево, не дорого)
    const optimalPriceBonus =
      buyout <= 200000
        ? 1500 // очень выгодно
        : buyout <= 500000
        ? 2000 // выгодно
        : buyout <= 1000000
        ? 500 // приемлемо
        : buyout <= 2000000
        ? 200
        : 0 // дорого

    // Бонус за хорошие данные (стабильная статистика)
    const goodDataBonus =
      (ACSalesCount >= 5 ? 600 : 0) +
      (BCSalesCount >= 5 ? 600 : 0) +
      affixSalesCount * 100 +
      (ACSalesCount >= 5 && BCSalesCount >= 5 ? 1000 : 0) // бонус за хорошие данные по обоим

    // Бонус за стабильность цен с увеличенными значениями
    const stabilityScore =
      coefficientOfVariation > 25
        ? -500
        : coefficientOfVariation > 15
        ? -200
        : coefficientOfVariation < 8
        ? 400
        : coefficientOfVariation < 12
        ? 150
        : 0

    // Бонус за надежность данных - чем ниже coefficientOfVariation, тем выше надежность
    const reliabilityScore =
      coefficientOfVariation < 5
        ? 1500 // очень надежные данные
        : coefficientOfVariation < 8
        ? 1000 // надежные данные
        : coefficientOfVariation < 12
        ? 500 // приемлемые данные
        : coefficientOfVariation < 20
        ? 200 // средние данные
        : 0 // ненадежные данные

    // Мультипликатор за баланс показателей
    const balanceMultiplier =
      liquidityPerDay >= 5 && profit > 50000 && buyout <= 500000
        ? 1.3 // идеальный баланс
        : liquidityPerDay >= 3 && profit > 0 && buyout <= 1000000
        ? 1.2 // хороший баланс
        : liquidityPerDay >= 1 && buyout <= 2000000
        ? 1.1 // приемлемый баланс
        : 1

    let score =
      (salesScore +
        liquidityScore +
        profitScore +
        affixLiquidityScore +
        optimalPriceBonus +
        goodDataBonus +
        stabilityScore +
        reliabilityScore) *
      balanceMultiplier

    // Условия надежности данных (для балансированной формулы)
    const hasReliableData =
      affixLiquidityPerDay >= 0.5 || // минимальная ликвидность
      ACSalesCount >= 3 ||
      BCSalesCount >= 3 || // базовые данные по компонентам
      totalWeight >= 0.5 // минимальный вес данных

    // Если профит слишком отрицательный или совсем нет данных, обнуляем score
    if (!hasReliableData || profit < 200000) {
      score = 0
    }

    return {
      buyoutPrice: buyout,
      marketPrice: weightedMarketPrice, // обновлено на взвешенную цену
      netMarketPrice, // добавлена чистая цена после комиссии
      profit,
      price,
      salesCount,
      liquidityPerDay,
      affixPrice,
      affixLiquidityPerDay,
      affixSalesCount,
      score,
      // Новые метрики надежности
      priceVariance,
      priceStdDev,
      coefficientOfVariation,
      hasReliableData,
      // suffixQualityNumber: statsRandom,
      prefix: l.prefix,
      suffix: l.suffix,
      affix: l.affix,
      AC: {
        ...AC,
        avgPrice: ACPrice,
        salesCount: ACSalesCount
      },
      BC: {
        ...BC,
        avgPrice: BCPrice,
        salesCount: BCSalesCount
      }
    }
  })
})

function formatPrice(n: number) {
  return n?.toLocaleString()
}

function profitClass(v: number) {
  if (v > 0) return 'profit'
  if (v < 0) return 'loss'
  return ''
}

const getQuality = (quality: number) => {
  return QUALITY_LIST.find(q => q.value === quality)
}

/* копирование */

const toast = ref()
const searchQuery = ref('')
const filteredSuggestions = ref([])

/* Фильтры */
const filters = reactive({
  prefixDefinitionIds: [],
  suffixDefinitionIds: [],
  affixDefinitionIds: [],
  prefixQualities: [],
  suffixQualities: [],
  affixQualities: []
})

const qualityOptions = QUALITY_LIST

const toggleQuality = (key, value) => {
  const arr = filters[key]
  const i = arr.indexOf(value)
  i > -1 ? arr.splice(i, 1) : arr.push(value)
}

// Функция для получения parameterRu по ID
const getParameterRu = (id: string, slot: string) => {
  // Очищаем ID от суффиксов если они есть
  const cleanId = id.replace(/_(pre|suf|aff)$/, '')
  const stat = MODULE_STATS.find(m => m.id === cleanId && m.slots.includes(slot))
  return stat?.parameterRu || ''
}

/* Options */
const prefixOptions = computed(() =>
  MODULE_STATS.filter(m => m.slots.includes('prefix')).map(m => ({
    label: m.nameRu,
    value: m.id
  }))
)

const suffixOptions = computed(() =>
  MODULE_STATS.filter(m => m.slots.includes('suffix')).map(m => ({
    label: m.nameRu,
    value: m.id
  }))
)

const affixOptions = computed(() =>
  MODULE_STATS.filter(m => m.slots.includes('affix')).map(m => ({
    label: m.nameRu,
    value: m.id
  }))
)

const copyingNotification = (text: string) => {
  toast.value?.add({
    severity: 'info',
    summary: 'Скопировано',
    detail: text,
    life: 2000
  })
}

const copyToClipboard = (text: string, type?: string) => {
  let copyValue = text

  // Если это цена, вычитаем 1 рубль
  if (type === 'price') {
    const numValue = parseFloat(text.replace(/[^\d.-]/g, ''))
    if (!isNaN(numValue)) {
      copyValue = (numValue - 1).toString()
    }
  }

  copyingNotification(copyValue)

  copyText(copyValue, undefined, (error: Error) => {
    if (error) console.error('Copy error:', error)
  })
}

const goToModuleHistory = (moduleData: any) => {
  const query: any = {}

  // Функция для очистки ID от суффиксов
  const cleanDefinitionId = (definitionId: string) => {
    return definitionId?.replace(/_(pre|suf|aff)$/g, '').replace(/_(pre|suf|aff)_?/g, '')
  }

  // Добавляем префикс если есть
  if (moduleData.prefix?.definitionId) {
    query.prefix = cleanDefinitionId(moduleData.prefix.definitionId)
    if (moduleData.prefix.quality !== undefined) {
      query.prefixQualities = moduleData.prefix.quality
    }
  }

  // Добавляем суффикс если есть
  if (moduleData.suffix?.definitionId) {
    query.suffix = cleanDefinitionId(moduleData.suffix.definitionId)
    if (moduleData.suffix.quality !== undefined) {
      query.suffixQualities = moduleData.suffix.quality
    }
  }

  // Добавляем аффикс если есть
  if (moduleData.affix?.definitionId) {
    query.affix = cleanDefinitionId(moduleData.affix.definitionId)
    if (moduleData.affix.quality !== undefined) {
      query.affixQualities = moduleData.affix.quality
    }
  }

  // Строим URL с query-параметрами
  const queryString = new URLSearchParams(query).toString()
  const url = `/module${queryString ? '?' + queryString : ''}`

  // Открываем в новой вкладке
  window.open(url, '_blank')
}

/* Поиск атрибутов */
const searchAttributes = event => {
  if (!event || !event.query) {
    filteredSuggestions.value = []
    return
  }

  const query = event.query.toLowerCase()
  if (!query || query.length < 2) {
    filteredSuggestions.value = []
    return
  }

  // Ищем по всем названиям атрибутов
  const allAttributes = (MODULE_STATS || [])
    .map(stat => ({
      name: stat.nameRu || '',
      id: stat.id || '',
      slot: stat.slots && stat.slots[0] ? stat.slots[0] : 'unknown'
    }))
    .filter(attr => attr.name && attr.id) // фильтруем пустые значения

  const matches = allAttributes.filter(attr => attr.name.toLowerCase().includes(query))

  filteredSuggestions.value = matches.slice(0, 10) // ограничиваем количество предложений
}

const handleAttributeSelect = event => {
  if (event.value && event.value.name) {
    searchQuery.value = event.value.name
  }
}

const clearSearch = () => {
  searchQuery.value = ''
  filteredSuggestions.value = []
}
// Директива v-tooltip уже доступна глобально через PrimeVue

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast), {
      ref_key: "toast",
      ref: toast
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.dashboard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[4] || (_cache[4] = _createElementVNode("label", null, "Надстройка (Prefix)", -1)),
              _createVNode(_unref(MultiSelect), {
                modelValue: filters.prefixDefinitionIds,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.prefixDefinitionIds) = $event)),
                options: prefixOptions.value,
                optionLabel: "label",
                optionValue: "value",
                display: "chip",
                filter: ""
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualityOptions), (q) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: 'p-' + q.value,
                    style: _normalizeStyle({ backgroundColor: q.color }),
                    class: _normalizeClass({ active: filters.prefixQualities.includes(q.value) }),
                    onClick: ($event: any) => (toggleQuality('prefixQualities', q.value))
                  }, null, 14, _hoisted_5))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("label", null, "Отклонение (Suffix)", -1)),
              _createVNode(_unref(MultiSelect), {
                modelValue: filters.suffixDefinitionIds,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.suffixDefinitionIds) = $event)),
                options: suffixOptions.value,
                optionLabel: "label",
                optionValue: "value",
                display: "chip",
                filter: ""
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualityOptions), (q) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: 's-' + q.value,
                    style: _normalizeStyle({ backgroundColor: q.color }),
                    class: _normalizeClass({ active: filters.suffixQualities.includes(q.value) }),
                    onClick: ($event: any) => (toggleQuality('suffixQualities', q.value))
                  }, null, 14, _hoisted_8))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("label", null, "Концепт (Affix)", -1)),
              _createVNode(_unref(MultiSelect), {
                modelValue: filters.affixDefinitionIds,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.affixDefinitionIds) = $event)),
                options: affixOptions.value,
                optionLabel: "label",
                optionValue: "value",
                display: "chip",
                filter: ""
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualityOptions), (q) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: 'a-' + q.value,
                    style: _normalizeStyle({ backgroundColor: q.color, color: q.color }),
                    class: _normalizeClass({ active: filters.affixQualities.includes(q.value) }),
                    onClick: ($event: any) => (toggleQuality('affixQualities', q.value))
                  }, null, 14, _hoisted_11))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[8] || (_cache[8] = _createElementVNode("label", null, "Быстрый поиск по названиям", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(AutoComplete), {
                  modelValue: searchQuery.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQuery).value = $event)),
                  suggestions: filteredSuggestions.value,
                  optionLabel: "name",
                  placeholder: "Введите название атрибута...",
                  onComplete: searchAttributes,
                  onSelect: handleAttributeSelect,
                  class: "search-autocomplete",
                  dropdown: true,
                  minLength: 2
                }, null, 8, ["modelValue", "suggestions"]),
                (searchQuery.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: clearSearch,
                      class: "clear-button"
                    }, _cache[7] || (_cache[7] = [
                      _createTextVNode(" ✕ ", -1)
                    ]))), [
                      [_directive_tooltip, 'Очистить поиск']
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(DataTable), {
        value: filteredRows.value,
        stripedRows: "",
        sortMode: "multiple",
        multiSortMeta: multiSortMeta.value,
        responsiveLayout: "scroll",
        paginator: true,
        rows: 25,
        rowsPerPageOptions: [10, 25, 50, 100],
        currentPageReportTemplate: "Показано {first} - {last} из {totalRecords}",
        class: "table"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            header: "Модули",
            style: {"min-width":"300px"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: "attrs",
                onClick: ($event: any) => (
              copyToClipboard(
                `${slotProps.data.prefix.name} ${slotProps.data.suffix.name} ${slotProps.data.affix.name}`
              )
            )
              }, [
                _createElementVNode("span", {
                  style: _normalizeStyle(`color: ${getQuality(slotProps.data.prefix.quality)?.color}`)
                }, _toDisplayString(slotProps.data.prefix.name), 5),
                _createElementVNode("span", {
                  style: _normalizeStyle(`color: ${getQuality(slotProps.data.suffix.quality)?.color}`)
                }, _toDisplayString(slotProps.data.suffix.name), 5),
                _createElementVNode("span", {
                  style: _normalizeStyle(`color: ${getQuality(slotProps.data.affix.quality)?.color}`)
                }, _toDisplayString(slotProps.data.affix.name), 5)
              ], 8, _hoisted_14)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Выкуп",
            sortable: "",
            field: "buyoutPrice"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(formatPrice(slotProps.data.buyoutPrice)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Цена продажи",
            sortable: "",
            field: "marketPrice"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (copyToClipboard(Math.round(slotProps.data.marketPrice).toString(), 'price')),
                  class: "clickable-price"
                }, _toDisplayString(formatPrice(Math.round(slotProps.data.marketPrice))), 9, _hoisted_15)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Первый атрибут",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                style: _normalizeStyle({
              color:
                slotProps.data.AC?.avgPrice < slotProps.data?.marketPrice
                  ? '#ff6b6b'
                  : slotProps.data.AC?.avgPrice > slotProps.data?.marketPrice
                  ? '#51cf66'
                  : 'inherit'
            })
              }, _toDisplayString(formatPrice(slotProps.data.AC?.avgPrice)), 5),
              _createElementVNode("div", _hoisted_16, _toDisplayString(getParameterRu(slotProps.data.prefix.definitionId, 'prefix')), 1),
              (slotProps.data.AC?.salesCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(slotProps.data.AC?.salesCount), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Второй атрибут",
            sortable: ""
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                style: _normalizeStyle({
              color:
                slotProps.data.BC?.avgPrice < slotProps.data?.marketPrice
                  ? '#ff6b6b'
                  : slotProps.data.BC?.avgPrice > slotProps.data?.marketPrice
                  ? '#51cf66'
                  : 'inherit'
            })
              }, _toDisplayString(formatPrice(slotProps.data.BC?.avgPrice)), 5),
              _createElementVNode("div", _hoisted_18, _toDisplayString(getParameterRu(slotProps.data.suffix.definitionId, 'suffix')), 1),
              (slotProps.data.BC?.salesCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(slotProps.data.BC?.salesCount), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Третий атрибут",
            sortable: "",
            field: "affixPrice"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(formatPrice(slotProps.data.affixPrice)), 1),
                _createElementVNode("div", _hoisted_20, _toDisplayString(getParameterRu(slotProps.data.affix.definitionId, 'affix')), 1),
                (slotProps.data.affixSalesCount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(slotProps.data.affixSalesCount), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Точное попадание из трех атрибутов",
            sortable: "",
            field: "price"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                style: _normalizeStyle({
              color:
                slotProps.data?.price < slotProps.data?.marketPrice
                  ? '#ff6b6b'
                  : slotProps.data?.price > slotProps.data?.marketPrice
                  ? '#51cf66'
                  : 'inherit'
            })
              }, _toDisplayString(formatPrice(slotProps.data?.price)), 5),
              (slotProps.data.salesCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(slotProps.data.salesCount), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Профит",
            sortable: "",
            field: "profit"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                onClick: ($event: any) => (copyToClipboard(slotProps.data.profit.toString(), 'price')),
                class: _normalizeClass([profitClass(slotProps.data.profit), "clickable-price"])
              }, _toDisplayString(formatPrice(slotProps.data.profit)), 11, _hoisted_23)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Продаж в день основного атрибута",
            sortable: "",
            field: "affixLiquidityPerDay"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.affixLiquidityPerDay?.toFixed(2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "Очки",
            sortable: "",
            field: "score"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.score.toFixed(2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            header: "История",
            style: {"width":"80px","text-align":"center"}
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_unref(Button), {
                icon: "pi pi-external-link",
                class: "p-button-rounded p-button-sm history-button",
                onClick: ($event: any) => (goToModuleHistory(slotProps.data))
              }, null, 8, ["onClick"]), [
                [_directive_tooltip, 'View module history']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "multiSortMeta"])
    ])
  ], 64))
}
}

})